import { encrypt, getServiceToken } from './encryption';
import { API } from '../interceptors/axios';

export const fetchAuth = async () => {
    try {        
        const encryptedData = encrypt(process.env.REACT_APP_USER);
        
        const res = await API.post(
            `${process.env.REACT_APP_API_URL}/options/`,
            { data: encryptedData },
            {
                headers: {
                    'Content-Type': 'application/json',
                    'x-service-token': getServiceToken()
                },
                withCredentials: true
            }
        );

        // Server sets httpOnly cookie — also store token for Authorization header fallback
        if (res.data && res.data.token) {
            localStorage.setItem('token', res.data.token);
            // Store expiry so the request interceptor can refresh proactively
            localStorage.setItem('tokenExpiresAt', Date.now() + 10 * 1000);
            return res.data.token;
        }

        throw new Error('No token received');
    } catch (err) {
        console.error('Authentication failed:', err);
        if (!err.response) throw err;
        if (err.response?.status === 403) window.location.href = '/login';
        throw err;
    }
}